import { Icon } from '@silverfalls/sterling';
import type { JSX } from 'react';

// Sterling-styled filter input — left search icon, right clear-X when
// non-empty. Replaces the bare <input type="search"> on list screens.
// Width / height come from .filter-input-wrap in app.css.
interface FilterInputProps {
  readonly value: string;
  readonly onChange: (next: string) => void;
  readonly placeholder?: string;
  readonly ariaLabel: string;
}

export function FilterInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: FilterInputProps): JSX.Element {
  return (
    <div className="filter-input-wrap">
      <span className="filter-input-icon">
        <Icon name="search" size={14} />
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      {value !== '' && (
        <button
          type="button"
          className="filter-input-clear"
          onClick={() => onChange('')}
          aria-label="Clear filter"
          title="Clear filter"
        >
          <Icon name="x" size={14} />
        </button>
      )}
    </div>
  );
}
